export function boolify(input?: boolean | string) {
  return typeof input === 'boolean' ? input : input === 'true';
}
